import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import Modal from '.';

export default function RejectRequestModal({
  open,
  onClose,
  onAction,
  onCancel,
  isDataSubmitting,
  value,
  onChange
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Reject Request"
      cancelText="Cancel"
      actionText="Reject"
      onAction={onAction}
      onCancel={onCancel}
      isCancelDisabled={isDataSubmitting}
      isBtnLoading={isDataSubmitting}
    >
      <TextField
        margin="dense"
        fullWidth
        id="student-notes"
        label="Notes"
        name="note"
        multiline
        maxRows={4}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </Modal>
  );
}

RejectRequestModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAction: PropTypes.func,
  onCancel: PropTypes.func,
  isDataSubmitting: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func
};
